import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

export default function sliderContacts() {
  new Swiper('.swiper-contacts', {
    modules: [Navigation, Autoplay],
    slidesPerView: 1,
    spaceBetween: 8,
    grabCursor: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    navigation: {
      prevEl: '.contacts__navigation .swiper-button-prev',
      nextEl: '.contacts__navigation .swiper-button-next'
    },
    breakpoints: {
      600: {
        spaceBetween: 8,
        slidesPerView: 2,
      },
      1110: {
        spaceBetween: 34,
        slidesPerView: 2,
      }
    }
  });  
}
sliderContacts();